import { candleParser } from '../candleParser';

/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645473622228,
	"notificationDetails": {"updateType":"SETUP_FILTERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"failedEmas":[{"periodLength":2,"emaCandleDuration":0,"maCurrentPrice":0.0}],"candleDuration":15,"timeUnit":"MINUTES","candle":{"high":100.2,"low":100.2,"open":100.2,"close":100.2,"candleSymbol":"XTz","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":0.0,"tradeDirection":null,"tacticName":"EMA_INTERSECTS_FIRST_CANDLE","symbol":"xyz"},
	"date": "2022-02-21T15:00:22.810-0500",
	"timestamp": "1645473622813"
}

 * @param {*} pluginTemplate 
 * @returns object with following fields:
 * 1) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 * 2) faileEmas (array of objects with fields: 1) periodLength, emaCandleDuration, maCurrentPrice)
 */
export function emaIntersectsFirstCandleParser(pluginTemplate) {
  const parsedObject = {
    candle: null,
    failedEmas: null, //array with fields: 1) periodLength, emaCandleDuration, maCurrentPrice
  };
  if (pluginTemplate) {
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
    parsedObject.failedEmas = pluginTemplate.failedEmas
      ? pluginTemplate.failedEmas
      : null;
  }
  return parsedObject;
}
